module.exports = __webpack_public_path__ + "static/media/arn.a70b8cca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/arn.jpg
// module id = 197
// module chunks = 0